import { render, staticRenderFns } from "./AacademicaMedicineReports.vue?vue&type=template&id=7fcad288"
import script from "./AacademicaMedicineReports.vue?vue&type=script&lang=js"
export * from "./AacademicaMedicineReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports